import {InputProvider} from 'components/common/CartItemBuilder/providers/InputProvider'
import {ErrorMessage} from 'components/common/ErrorMessage'
import {useEffect, useState} from 'react'
import {ConfirmButton} from './ConfirmButton'

export const Confirming = () => {
  const input = InputProvider.useInput()
  const [error, setError] = useState<unknown>()

  useEffect(() => {
    setError(null)
  }, [input])

  return (
    <>
      {error && <ErrorMessage error={error} />}
      <ConfirmButton onError={setError} />
    </>
  )
}
